import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CHECKOUT_URL, HERO_IMAGE } from '../data/hvac';
const INCLUDES = ['Visual diagnostic maps', 'Troubleshooting flowcharts', 'Symptom-based pathways', 'Testing sequences', 'Component references', 'Pressure & measurement resources', 'Professional field-ready tools'];
export function SystemSection() {
  return <section className="border-y-4 border-hvac/20 bg-white px-4 py-5 sm:py-7" data-id="element-176" data-mp="31kpayx9j5kfz">
      <div className="mx-auto max-w-4xl" data-id="element-177" data-mp="31mtom6x8dxtg">
        <h2 className="text-center text-xl leading-tight text-navy sm:text-3xl" data-id="element-178" data-mp="2wtqrjot8w68i">
          The Complete 6-in-1 Visual Diagnostic System
        </h2>

        <div className="mt-3 grid items-center gap-4 sm:grid-cols-2" data-id="element-179" data-mp="2sqay11ch2m01">
          <a href={CHECKOUT_URL} className="block" data-id="element-180" data-mp="2nulsmhdruavt">
            <img src={HERO_IMAGE} alt="The complete HVAC DIAGNOSTIC READY™ system: 6 modules and 4 bonuses" loading="lazy" className="mx-auto w-full max-w-sm" data-id="element-181" data-mp="2iu7tjou5eb9x" />
          </a>

          <div data-id="element-182" data-mp="13yg2q0up8t0p">
            <p className="font-display text-xl uppercase leading-none text-navy sm:text-2xl" data-id="element-183" data-mp="13xwvbe2odn0x">
              🔧 HVAC DIAGNOSTIC READY™
            </p>
            <p className="mt-1 text-xs font-extrabold uppercase tracking-wide text-hvac sm:text-sm" data-id="element-184" data-mp="u1k3klqoxj8t">
              Ready-to-use visual troubleshooting for HVAC technicians
            </p>
            <p className="mt-1 text-sm font-semibold text-charcoal/80" data-id="element-185" data-mp="1mpz3s255xx03">
              Cooling • Airflow • Electrical • Refrigerant • Compressor • Field Troubleshooting
            </p>
            <ul className="mt-2 grid gap-1" data-id="element-186" data-mp="1rmg2fq9zntrf">
              {INCLUDES.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold text-charcoal" data-id="element-187" data-mp="1ctma349mbj5c">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-service" aria-hidden="true" strokeWidth={3} data-id="element-188" data-mp="1bbgqgl7manw" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}